import * as React from "react";
import * as ComparePriceStyles from "../styles/ComparePrice";
import IconTag from "../../../../../common-deprecated/svg/toyota/tag.svg";
import type { EquipmentSpecNameIdValueType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import { useCompareV2Selector } from "../../../redux/store";
import { getModelMapValueById } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import IconWrapper from "../../../../../common-deprecated/styles/toyota/IconWrapper";
import {
    formatAEMCashPrice,
    getAemPriceConfig,
    hasDualCurrency,
    showAemPriceExclVAT,
} from "../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { useCompareV2Label } from "../../../utils/labels";
import { SrOnly } from "../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import { AemFmComponent } from "../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";

type ComparePriceAtomPropsType = {
    index: number;
    price?: EquipmentSpecNameIdValueType["price"];
    cultureName: string;
    showPrices: boolean;
};

const EquipmentOrSpecPrice = (props: ComparePriceAtomPropsType): JSX.Element | null => {
    const { cultureName, price, showPrices, index } = props;

    const hasSecondaryPrice = useCompareV2Selector((state) => hasDualCurrency(state.commonSettings));
    const modelMap = useCompareV2Selector((state) =>
        getModelMapValueById(state.commonSettings, state.newCarCompare.grades[index]?.modelId, false),
    );

    const showPriceExclVat = useCompareV2Selector((state) =>
        showAemPriceExclVAT(state.commonSettings, AemFmComponent.Compare, "new", modelMap?.internalCode),
    );

    const priceConfig = useCompareV2Selector((state) =>
        getAemPriceConfig(state.commonSettings, AemFmComponent.Compare, modelMap?.internalCode),
    );

    const promotionLabel = useCompareV2Label("compareBodyLegendPromotion");

    const normalPrice = showPriceExclVat ? price?.net : price?.list;
    const discountedPrice = showPriceExclVat ? price?.netWithDiscount : price?.listWithDiscount;

    if (!normalPrice || !showPrices) {
        return null;
    }

    if (normalPrice === discountedPrice) {
        return (
            <ComparePriceStyles.PriceWrapper>
                <ComparePriceStyles.Price>
                    <span
                        dangerouslySetInnerHTML={{ __html: formatAEMCashPrice(normalPrice, cultureName, priceConfig) }}
                    />
                </ComparePriceStyles.Price>
                {/* Dual currency price */}
                {hasSecondaryPrice && (
                    <ComparePriceStyles.Price>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: formatAEMCashPrice(normalPrice, cultureName, priceConfig, undefined, true),
                            }}
                        />
                    </ComparePriceStyles.Price>
                )}
            </ComparePriceStyles.PriceWrapper>
        );
    } else {
        return (
            <>
                <IconWrapper iconColor="primary">
                    <IconTag aria-hidden="true" />
                    <SrOnly>{promotionLabel}</SrOnly>
                </IconWrapper>
                <ComparePriceStyles.LineThrough>
                    <span
                        dangerouslySetInnerHTML={{ __html: formatAEMCashPrice(normalPrice, cultureName, priceConfig) }}
                    />
                </ComparePriceStyles.LineThrough>
                <ComparePriceStyles.Discount>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: formatAEMCashPrice(discountedPrice!, cultureName, priceConfig),
                        }}
                    />
                </ComparePriceStyles.Discount>
            </>
        );
    }
};

export default EquipmentOrSpecPrice;
